var React = require('react');

function Exclude (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M26.9301 12.7027H40V26.9257H26.9301V40H13.07V26.9257H0V12.7027H13.07V0H26.9301V12.7027ZM13.0713 26.7234V12.9397C13.0713 12.7707 13.2688 12.7032 13.4005 12.737L26.7997 19.6289C26.9643 19.7302 26.9643 19.9329 26.7997 20.0005L13.4005 26.8924C13.2688 26.9937 13.0713 26.8924 13.0713 26.7234Z","fill":"currentColor"}));
}

Exclude.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Exclude;

Exclude.default = Exclude;
